<template>
    <div class="d-md-flex align-items-center mr-0" v-if="isCheckbox">
        <label class="custom-formField d-flex align-items-center mt-1" :class="{'konfiguratorRow__activator' : isActivator}">
            <input type="checkbox" v-model="valueHolder"/>
            <span style="width: initial;">{{ technicalParameter.name }}</span>
            <div v-if="technicalParameter.id === 1079 && productTypeId === 5" class="mx-1 tooltip js-tooltip">

                <span class="tooltip__icon">?</span>
                <div class="tooltip__window">
                    {{ $t("components.TechnicalParameterInput.oxfordStyleTooltip") }}<br>
                    <img
                        src="/images/foto/collections/11/20.jpg"
                        alt=""
                        style="max-width: 200px; max-height: 200px;"
                    >
                </div>
            </div>
        </label>

    </div>
    <label class="custom-formField--select chosen-configurator mb-0 mr-md-2" v-else-if="isSelectbox" :class="{'konfiguratorRow__activator' : isActivator, 'd-none readonly' : isDisabled, ['chosen-configurator-' + technicalParameter.id]: true}">
        <vue-chosen
            :name="formName"
            :values="chosenValues"
            :customIsSelected="customIsSelected"
            :withCustom="withCustom"
            :dimensions="dimensions"
            :product="product"
            @customDimensionsOpen="$emit('customDimensionsOpen')"
            v-model="valueHolder"></vue-chosen>
    </label>
    <div class="d-md-flex align-items-center mr-0" v-else-if="isSelectboxGrouped">
        <label class="custom-formField--select chosen-configurator mb-0 mr-md-2"  :class="{'konfiguratorRow__activator' : isActivator, 'd-none readonly' : isDisabled, ['chosen-configurator-' + technicalParameter.id]: true}">
            <vue-chosen
                :name="formName"
                :customIsSelected="customIsSelected"
                :values="chosenValues"
                :withCustom="withCustom"

                :dimensions="dimensions"
                :product="product"
                :fabric="fabric"
                @customDimensionsOpen="$emit('customDimensionsOpen')"
                v-model="valueHolder"></vue-chosen>
        </label>
        <div v-if="technicalParameter.id === 1078 && productTypeId === 5" class="ml-md-1 mt-2 mt-md-0 d-flex align-items-center">

            <div class="">
                <span class="tooltip__text">
                    {{ $t("components.TechnicalParameterInput.oxfordStyleWhatIs") }}
                </span>
                <div class="tooltip tooltip--dark js-tooltip">
                    <span class="tooltip__icon">?</span>
                    <div class="tooltip__window">
                        {{ $t("components.TechnicalParameterInput.oxfordStyleTooltip") }}<br>
                        <img
                            src="/images/oxford-style-tooltip.jpg"
                            alt=""
                            class="mt-2"
                            style="width: 290px;"
                        >
                    </div>
                </div>
            </div>
            <!-- Sem se na mobilu přesouvá odkaz jak měřit - vím, je to debilní, ale líp to teď nejde -->
            <div class="ml-auto js-konfigurator-how-to-mesure-mobile-wrap"></div>
        </div>



    </div>
    <input type="hidden" v-else-if="isHidden" v-model="valueHolder"/>
    <div class="description" v-else-if="fixed">
        <input type="hidden" v-model="valueHolder"/>
        <div v-if="technicalParameter.type === 'checkbox' && value">
            {{ technicalParameter.name }}
        </div>
        <div v-else-if="technicalParameter.type === 'selectbox' && technicalParameter.chainedId != null && value">
            {{ groupedValue }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            technicalParameter: {},
            product: {},
            fabric: {},
            customIsSelected: {},
            dimensions: {},
            fixed: {
                default: false,
                type: Boolean,
            },
            disabled: {
                default: false,
                type: Boolean
            },
            isActivator: {
                default: false,
                type: Boolean
            }
        },
        data: function () {
            var _this = this;
            var chained = this.product.parameters.find(function(tp) {return tp.id == _this.technicalParameter.chainedId;});
            var chainedValue = null;
            if(chained)  {
                chainedValue = chained.value;
            }
            return {
                value: this.technicalParameter.value,
                chainedValue: chainedValue,
                autoDisable: false
            };
        },
        computed: {
            productTypeId: function (){
                return this.product.type;
            },
            withCustom: function () {
                // // Is customizable
                // let isCustomizable = false;
                // const customizableProductTypesIds = [
                //    // 7, // sheet (Prostěradlo)
                //     6, // duvet (Peřina)
                //     5, // pillow (Polštář)
                //     // 4, // duvet (Peřina)
                //     // 3  // pillow (Polštář)
                // ];
                // if(customizableProductTypesIds.includes(this.productTypeId)){
                //     isCustomizable = true;
                // }
                //
                // // Is dimensions technical param
                // let isDimensionsTP = false;
                // const dimensionsTPIds = [
                //     1078 // rozměry
                // ];
                // if(dimensionsTPIds.includes(this.technicalParameter.id)){
                //     isDimensionsTP = true;
                // }
                //
                // if(isCustomizable && isDimensionsTP) {
                //     return true;
                // }
                return false;
            },
            isSelectbox: function () {
                return (
                    this.technicalParameter.type == "selectbox"
                    && this.technicalParameter.chainedId == null
                    && !this.fixed
                );
            },
            isSelectboxGrouped: function () {
                return (
                    this.technicalParameter.type == "selectbox"
                    && this.technicalParameter.chainedId != null
                    && !this.fixed
                );
            },
            isChained: function () {
                return this.technicalParameter.chainedId != null;
            },
            isCheckbox: function () {
                return this.technicalParameter.type == "checkbox" && !this.fixed;
            },
            isHidden: function () {
                return this.technicalParameter.type == "hidden" && !this.fixed;
            },
            isFixed: function () {
                return this.fixed;
            },
            isDisabled: function() {
              return this.disabled || this.autoDisable;
            },
            values: function () {
                return this.$store.getters.getTPValues(
                    this.productTypeId,
                    this.technicalParameter.id,
                    this.technicalParameter.chainedId
                );
            },
            technicalParamName: function () {
                return this.technicalParameter.name.toLowerCase();
            },
            formName: function () {
                if(this.technicalParameter.formName !== '') {
                    return this.technicalParameter.formName;
                }
                return this.$t('components.TechnicalParameterInput.selectTechnicalParameter', {'paramName': this.technicalParamName})
            },
            chosenValues: function () {
                if (this.isSelectbox) {
                    return this.values.map(function (value) {
                        return {
                            id: value.id,
                            label: value.value
                        };
                    });
                }
                if (this.isSelectboxGrouped) {
                    return this.values.map(function (group) {
                        var label = group.chainedValue.value;
                        var isBool = typeof label === "boolean";
                        if(isBool) {
                            label = label ? '<b>oxford</b>' : 'classic';
                        }
                        return {
                            id: !isBool ? group.chainedValue.id : group.chainedValue.value,
                            label: label,
                            items: group.values.map(function (value) {
                                return {
                                    id: value.id,
                                    label: value.value
                                };
                            })
                        };
                    });
                }
                return [];
            },
            groupedValue() {
                if (!this.technicalParameter.type == "selectbox"
                    || this.technicalParameter.chainedId == null) {
                    return '';
                }
                const val = this.value;
                const found = this.values.find(function (item) {
                    return item.values.find(function(subIt) {
                        return subIt.id === val;
                    });
                });
                if (!found) {
                    return '';
                }
                var subVal = found.values.find(function(subIt) {
                    return subIt.id === val;
                });
                return subVal.value + ' (' + found.chainedValue.value + ') ';
            },
            valueHolder: {
                get: function () {
                    return !this.isChained ? this.value : {id:this.value, chainedValue: this.chainedValue};
                },
                set: function (value) {
                    var values = [];
                    if(typeof value === 'object' && value !== null) {
                        this.value = value.id;
                        this.chainedValue = value.chainedValue;
                        values = [{tpId: this.technicalParameter.id, value: value.id}, {tpId: this.technicalParameter.chainedId, value: value.chainedValue}];
                    } else  {
                        this.value = value;
                        values = [{tpId: this.technicalParameter.id, value: value}];
                    }
                    this.$emit("setValues", {values: values});
                }
            },
        },
        created() {
            let defaultValue = false;
            try {
                if (this.chosenValues.length === 1) {
                    if (this.isSelectboxGrouped) {
                        if (this.chosenValues[0].items.length === 1) {
                            defaultValue = {id: this.chosenValues[0].items[0].id, chainedValue: this.chosenValues[0].id};
                            // defaultValue = this.chosenValues[0].items[0].id;
                        }
                    } else {
                        defaultValue = this.chosenValues[0].id;
                    }
                }
            } catch (e) {
                // nothing
            }

            if (defaultValue !== false) {
                this.valueHolder = defaultValue;
                this.autoDisable = true;
            }
        }
    };
</script>
